// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28OPE","placeholdersHeader":"styles_placeholdersHeader__6Lrm7","editorStyle":"styles_editorStyle__3vbVg","placeholdersBox":"styles_placeholdersBox__QDIKx"};